import { cloneDeep } from 'lodash'
import moment from 'moment'

export function TimeFormat(time: string) {
    return moment.unix(+time).format('DD/MM/YYYY HH:mm')
}

export const isNumber = num => /^-?\d+(\.\d+)?$/.test(num)

export const dateForApi = (year, month) => {
    if (typeof year === 'number' && typeof month === 'number') {
        const date = new Date(`${month}-01-${year}`)
        return moment(date).format('YYYY-MM-DD')
    } else if (typeof year === 'number') {
        return year
    } else {
        return null
    }
}

export const subNames = {
    'מגן דוד כחול': 'מגן דוד כחול',
    'All-In': 'All-In',
    Assistant: 'Assistant',
    'MediWho 360': 'MediWho 360',
    'Best Care': 'Best Care',
    'Best Care smile': 'Best Care smile',
    'עד 120': 'nursing',
    'MediWho Gold': 'MediWho Gold',
    'Gold Plus': 'Gold Plus',
    'תושבי חוץ': 'תושבי חוץ',
    'Soul Care': 'Soul Care',
    'Bundle Soul Best Care': 'Soul+Best Care',
    'Bundle Soul Gold': 'Soul Care+gold',
    'Bundle Simple Smile Best Care': 'Simple Smile+Best Care',
    'Bundle Simple Smile Gold': 'Simple Smile+Gold',
    'Simple Smile': 'Simple Smile',
    'Mediwho Fly': 'Mediwho Fly'
}

export const downloadCommissionRows = res => {
    const url = window.URL.createObjectURL(new Blob([res.data]))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', 'clients.xlsx')
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    window.URL.revokeObjectURL(url)
}

// same as downloadStoRows but the caller picks the file name
export const downloadBlobFile = (res, fileName: string) => {
    const url = window.URL.createObjectURL(new Blob([res.data]))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', fileName)
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    window.URL.revokeObjectURL(url)
}

export const downloadStoRows = res => {
    const url = window.URL.createObjectURL(new Blob([res.data]))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', 'sto-list.xlsx')
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    window.URL.revokeObjectURL(url)
}

export const literalMonth = {
    1: 'ינואר',
    2: 'פברואר',
    3: 'מרץ',
    4: 'אפריל',
    5: 'מאי',
    6: 'יוני',
    7: 'יולי',
    8: 'אוגוסט',
    9: 'ספטמבר',
    10: 'אוקטובר',
    11: 'נובמבר',
    12: 'דצמבר'
}

function isJSON(str) {
    try {
        const parsed = JSON.parse(str)
        if (typeof parsed === 'object' && parsed !== null) {
            return parsed
        }
    } catch (e) {
        return null
    }
    return null
}

export const mentorsFormatter = (data, searchDate, searchId) => {
    return data.map((item: any) => {
        const parsedBudgetRows = isJSON(item.budget_rows) ? JSON.parse(item.budget_rows) : []
        const filteredBudgetRows = parsedBudgetRows.filter(row => {
            const usageDate = moment(row.created_at)
            const doSearch = searchDate && row.mentor_id === searchId ? moment(searchDate) : moment()
            return usageDate.isSame(doSearch, 'month') && usageDate.isSame(doSearch, 'year')
        })
        const sortedBudgetRows = filteredBudgetRows.sort((a: any, b: any) => {
            const dateA = new Date(a.usage_date)
            const dateB = new Date(b.usage_date)
            return dateB.getTime() - dateA.getTime()
        })
        return {
            ...item,
            budget_rows: sortedBudgetRows
        }
    })
}

export function DateFormat(time: string) {
    return moment.unix(+time).format('DD/MM/YYYY')
}

export function PhoneFormat(phone: string) {
    const formatPhone = phone.split('')
    formatPhone.splice(0, 4, '0').join('')
    return formatPhone
}

export function arrayNull(array, params) {
    return array == null ? '' : array[params]
}

export function validateEmail(value) {
    const reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return reg.test(value)
}

export function parseParentsTree(data) {
    const arr = []
    const addData = newObj => {
        arr.unshift({ id: newObj['id'], name: newObj['name'], parent_id: newObj['parent_id'] })
        if (newObj['parents']) {
            addData(newObj['parents'])
        }
    }

    addData(data)
    return arr
}

export function hashCategories(data) {
    const indexedParents = {}
    const indexedCategories = {}

    data.forEach(category => {
        indexedCategories[category.id] = category
        if (category['parent_id']) {
            indexedParents[category['parent_id']]
                ? indexedParents[category['parent_id']].push(category)
                : (indexedParents[category['parent_id']] = [category])
        } else {
            indexedParents['main_category']
                ? indexedParents['main_category'].push(category)
                : (indexedParents['main_category'] = [category])
        }
    })
    return { indexedParents, indexedCategories }
}

// Calculate priority status for inquiries
export function calcPriority(createdAt, dueDate, status) {
    const currentDate = moment().unix()
    const margin = dueDate - currentDate
    const taskTime = dueDate - createdAt
    const calc = (100 / taskTime) * margin

    let priority = '#329ee6'
    if (status !== 'DONE') {
        if (calc < 66) priority = '#ffb415'
        if (calc < 33) priority = '#f51717'
    } else {
        priority = '#76da16'
    }

    return priority
}

/**
 * setCookie
 *
 * @export
 * @param {string} name
 * @param {string} value
 * @param {number} [expiredays=365]
 */
export function setCookie(name: string, value: string, expiredays = 365) {
    const exdate = new Date()
    exdate.setDate(exdate.getDate() + expiredays)
    document.cookie = `${name}=${escape(value)};expires=${exdate.toUTCString()}`
}

/**
 * getCookie
 *
 * @export
 * @param {string} name
 * @returns
 */
export function getCookie(name: string) {
    if (document.cookie.length > 0) {
        let cStart = document.cookie.indexOf(name + '=')
        if (cStart !== -1) {
            cStart = cStart + name.length + 1
            let cEnd = document.cookie.indexOf(';', cStart)
            if (cEnd === -1) {
                cEnd = document.cookie.length
            }
            return unescape(document.cookie.substring(cStart, cEnd))
        }
    }
    return ''
}

/**
 * clearCookie
 *
 * @export
 * @param {string} name
 */
export function clearCookie(name: string) {
    setCookie(name, '')
}

export function getQueryStringParams(query) {
    return query
        ? (/^[?#]/.test(query) ? query.slice(1) : query).split('&').reduce((params, param) => {
              let [key, value] = param.split('=')
              params[key] = value ? decodeURIComponent(value.replace(/\+/g, ' ')) : ''
              return params
          }, {})
        : {}
}

/**
 *
 * @export
 * @param {string} name
 * @returns {string}
 */
export function queryURL(name: string): string {
    const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`, 'i')
    const result = window.location.search.substr(1).match(reg)
    if (result !== null) {
        return decodeURI(result[2])
    }
    return null
}

/**
 * 数组查询
 *
 * @export
 * @template T
 * @param {any[]} array
 * @param {string} key
 * @param {string} [keyAlias='key']
 * @returns {T}
 */
export function queryArray<T>(array: any[], key: string, keyAlias = 'key'): T {
    if (!(array instanceof Array)) {
        return null
    }
    const item = array.filter(a => a[keyAlias] === key)
    if (item.length) {
        return item[0]
    }
    return null
}

/**
 *
 *
 * @export
 * @template T
 * @param {any[]} array
 * @param {string} [id='id']
 * @param {string} [pid='pid']
 * @param {string} [children='children']
 * @returns {T[]}
 */
export function arrayToTree<T>(array: any[], id = 'id', pid = 'pid', children = 'children'): T[] {
    const data = cloneDeep(array)
    const result = []
    const hash = {}
    data.forEach((_, index) => {
        hash[data[index][id]] = data[index]
    })
    data.forEach(item => {
        const hashVP = hash[item[pid]]
        if (hashVP) {
            if (!hashVP[children]) {
                hashVP[children] = []
            }
            hashVP[children].push(item)
        } else {
            result.push(item)
        }
    })
    return result
}

export function isObjEmpty(obj) {
    return Object.keys(obj).length > 0
}

export const internationalCodes = [
    { value: '971', label: '🇦🇪 +971 (איחוד האמירויות)', show: true },
    { value: '972', label: '🇮🇱 +972 (ישראל)', show: true },
    { value: '1', label: '🇺🇸🇨🇦 +1 (ארה"ב / קנדה)', show: true },
    { value: '44', label: '🇬🇧 +44 (בריטניה)', show: true },
    { value: '49', label: '🇩🇪 +49 (גרמניה)', show: true },
    { value: '33', label: '🇫🇷 +33 (צרפת)', show: true },
    { value: '39', label: '🇮🇹 +39 (איטליה)', show: true },
    { value: '34', label: '🇪🇸 +34 (ספרד)', show: true },
    { value: '31', label: '🇳🇱 +31 (הולנד)', show: true },
    { value: '41', label: '🇨🇭 +41 (שוויץ)', show: true },
    { value: '46', label: '🇸🇪 +46 (שבדיה)', show: true },
    { value: '47', label: '🇳🇴 +47 (נורבגיה)', show: true },
    { value: '45', label: '🇩🇰 +45 (דנמרק)', show: true },
    { value: '48', label: '🇵🇱 +48 (פולין)', show: true },
    { value: '43', label: '🇦🇹 +43 (אוסטריה)', show: true },
    { value: '32', label: '🇧🇪 +32 (בלגיה)', show: true },
    { value: '420', label: "🇨🇿 +420 (צ'כיה)", show: true },
    { value: '421', label: '🇸🇰 +421 (סלובקיה)', show: true },
    { value: '36', label: '🇭🇺 +36 (הונגריה)', show: true },
    { value: '40', label: '🇷🇴 +40 (רומניה)', show: true },
    { value: '30', label: '🇬🇷 +30 (יוון)', show: true },
    { value: '351', label: '🇵🇹 +351 (פורטוגל)', show: true },
    { value: '90', label: '🇹🇷 +90 (טורקיה)', show: true },
    { value: '7', label: '🇷🇺🇰🇿 +7 (רוסיה / קזחסטן)', show: true },
    { value: '380', label: '🇺🇦 +380 (אוקראינה)', show: true },
    { value: '375', label: '🇧🇾 +375 (בלארוס)', show: true },
    { value: '995', label: '🇬🇪 +995 (גיאורגיה)', show: true },
    { value: '374', label: '🇦🇲 +374 (ארמניה)', show: true },
    { value: '994', label: "🇦🇿 +994 (אזרבייג'ן)", show: true },
    { value: '91', label: '🇮🇳 +91 (הודו)', show: true },
    { value: '92', label: '🇵🇰 +92 (פקיסטן)', show: true },
    { value: '880', label: '🇧🇩 +880 (בנגלדש)', show: true },
    { value: '94', label: '🇱🇰 +94 (סרי לנקה)', show: true },
    { value: '86', label: '🇨🇳 +86 (סין)', show: true },
    { value: '81', label: '🇯🇵 +81 (יפן)', show: true },
    { value: '82', label: '🇰🇷 +82 (דרום קוריאה)', show: true },
    { value: '852', label: '🇭🇰 +852 (הונג קונג)', show: true },
    { value: '853', label: '🇲🇴 +853 (מקאו)', show: true },
    { value: '65', label: '🇸🇬 +65 (סינגפור)', show: true },
    { value: '60', label: '🇲🇾 +60 (מלזיה)', show: true },
    { value: '62', label: '🇮🇩 +62 (אינדונזיה)', show: true },
    { value: '63', label: '🇵🇭 +63 (פיליפינים)', show: true },
    { value: '66', label: '🇹🇭 +66 (תאילנד)', show: true },
    { value: '84', label: '🇻🇳 +84 (וייטנאם)', show: true },
    { value: '61', label: '🇦🇺 +61 (אוסטרליה)', show: true },
    { value: '64', label: '🇳🇿 +64 (ניו זילנד)', show: true },
    { value: '27', label: '🇿🇦 +27 (דרום אפריקה)', show: true },
    { value: '20', label: '🇪🇬 +20 (מצרים)', show: true },
    { value: '212', label: '🇲🇦 +212 (מרוקו)', show: true },
    { value: '213', label: "🇩🇿 +213 (אלג'יריה)", show: true },
    { value: '216', label: '🇹🇳 +216 (תוניסיה)', show: true },
    { value: '218', label: '🇱🇾 +218 (לוב)', show: true },
    { value: '254', label: '🇰🇪 +254 (קניה)', show: true },
    { value: '255', label: '🇹🇿 +255 (טנזניה)', show: true },
    { value: '234', label: '🇳🇬 +234 (ניגריה)', show: true },
    { value: '233', label: '🇬🇭 +233 (גאנה)', show: true },
    { value: '52', label: '🇲🇽 +52 (מקסיקו)', show: true },
    { value: '55', label: '🇧🇷 +55 (ברזיל)', show: true },
    { value: '54', label: '🇦🇷 +54 (ארגנטינה)', show: true },
    { value: '56', label: "🇨🇱 +56 (צ'ילה)", show: true },
    { value: '57', label: '🇨🇴 +57 (קולומביה)', show: true },
    { value: '51', label: '🇵🇪 +51 (פרו)', show: true },
    { value: '58', label: '🇻🇪 +58 (ונצואלה)', show: true }
]

export const localCodes = {
    58: [
        { value: '412', label: '412' },
        { value: '414', label: '414' },
        { value: '415', label: '415' },
        { value: '416', label: '416' },
        { value: '422', label: '422' },
        { value: '424', label: '424' },
        { value: '426', label: '426' }
    ],
    51: [{ value: '9', label: '9' }],
    57: [{ value: '3', label: '3' }],
    56: [{ value: '9', label: '9' }],
    54: [{ value: '9', label: '9' }],
    55: [{ value: '9', label: '9' }],
    52: [],
    233: [
        { value: '20', label: '20' },
        { value: '23', label: '23' },
        { value: '24', label: '24' },
        { value: '25', label: '25' },
        { value: '26', label: '26' },
        { value: '27', label: '27' },
        { value: '28', label: '28' },
        { value: '50', label: '50' },
        { value: '53', label: '53' },
        { value: '54', label: '54' },
        { value: '55', label: '55' },
        { value: '56', label: '56' },
        { value: '57', label: '57' },
        { value: '59', label: '59' }
    ],
    234: [
        { value: '701', label: '701' },
        { value: '702', label: '702' },
        { value: '703', label: '703' },
        { value: '704', label: '704' },
        { value: '705', label: '705' },
        { value: '706', label: '706' },
        { value: '708', label: '708' },
        { value: '801', label: '801' },
        { value: '802', label: '802' },
        { value: '803', label: '803' },
        { value: '804', label: '804' },
        { value: '805', label: '805' },
        { value: '806', label: '806' },
        { value: '807', label: '807' },
        { value: '808', label: '808' },
        { value: '809', label: '809' },
        { value: '810', label: '810' },
        { value: '811', label: '811' },
        { value: '812', label: '812' },
        { value: '813', label: '813' },
        { value: '814', label: '814' },
        { value: '815', label: '815' },
        { value: '816', label: '816' },
        { value: '817', label: '817' },
        { value: '818', label: '818' },
        { value: '901', label: '901' },
        { value: '902', label: '902' },
        { value: '903', label: '903' },
        { value: '904', label: '904' },
        { value: '905', label: '905' },
        { value: '906', label: '906' },
        { value: '907', label: '907' },
        { value: '908', label: '908' },
        { value: '909', label: '909' },
        { value: '911', label: '911' },
        { value: '912', label: '912' },
        { value: '913', label: '913' },
        { value: '914', label: '914' },
        { value: '915', label: '915' },
        { value: '916', label: '916' }
    ],
    255: [
        { value: '61', label: '61' },
        { value: '62', label: '62' },
        { value: '65', label: '65' },
        { value: '67', label: '67' },
        { value: '68', label: '68' },
        { value: '69', label: '69' },
        { value: '71', label: '71' },
        { value: '73', label: '73' },
        { value: '74', label: '74' },
        { value: '75', label: '75' },
        { value: '76', label: '76' },
        { value: '77', label: '77' },
        { value: '78', label: '78' }
    ],
    254: [
        { value: '10', label: '10' },
        { value: '11', label: '11' },
        { value: '701', label: '701' },
        { value: '702', label: '702' },
        { value: '703', label: '703' },
        { value: '704', label: '704' },
        { value: '705', label: '705' },
        { value: '706', label: '706' },
        { value: '707', label: '707' },
        { value: '708', label: '708' },
        { value: '709', label: '709' },
        { value: '741', label: '741' },
        { value: '742', label: '742' },
        { value: '743', label: '743' },
        { value: '744', label: '744' },
        { value: '745', label: '745' },
        { value: '746', label: '746' },
        { value: '747', label: '747' },
        { value: '748', label: '748' },
        { value: '750', label: '750' },
        { value: '751', label: '751' },
        { value: '752', label: '752' },
        { value: '753', label: '753' },
        { value: '754', label: '754' },
        { value: '755', label: '755' },
        { value: '756', label: '756' },
        { value: '757', label: '757' },
        { value: '758', label: '758' },
        { value: '759', label: '759' },
        { value: '760', label: '760' },
        { value: '761', label: '761' },
        { value: '762', label: '762' },
        { value: '763', label: '763' },
        { value: '764', label: '764' },
        { value: '765', label: '765' },
        { value: '766', label: '766' },
        { value: '767', label: '767' },
        { value: '768', label: '768' },
        { value: '769', label: '769' },
        { value: '770', label: '770' },
        { value: '771', label: '771' },
        { value: '772', label: '772' },
        { value: '773', label: '773' },
        { value: '774', label: '774' },
        { value: '775', label: '775' },
        { value: '776', label: '776' },
        { value: '777', label: '777' },
        { value: '778', label: '778' },
        { value: '779', label: '779' },
        { value: '780', label: '780' },
        { value: '781', label: '781' },
        { value: '782', label: '782' },
        { value: '783', label: '783' },
        { value: '784', label: '784' },
        { value: '785', label: '785' },
        { value: '786', label: '786' },
        { value: '787', label: '787' },
        { value: '788', label: '788' },
        { value: '789', label: '789' },
        { value: '790', label: '790' },
        { value: '791', label: '791' },
        { value: '792', label: '792' },
        { value: '793', label: '793' },
        { value: '794', label: '794' },
        { value: '795', label: '795' },
        { value: '796', label: '796' },
        { value: '797', label: '797' },
        { value: '798', label: '798' },
        { value: '799', label: '799' }
    ],
    218: [
        { value: '91', label: '91' },
        { value: '92', label: '92' },
        { value: '93', label: '93' },
        { value: '94', label: '94' },
        { value: '95', label: '95' }
    ],
    216: [
        { value: '2', label: '2' },
        { value: '40', label: '40' },
        { value: '41', label: '41' },
        { value: '42', label: '42' },
        { value: '44', label: '44' },
        { value: '46', label: '46' },
        { value: '5', label: '5' },
        { value: '9', label: '9' }
    ],
    213: [
        { value: '5', label: '5' },
        { value: '6', label: '6' },
        { value: '7', label: '7' }
    ],
    212: [
        { value: '60', label: '60' },
        { value: '61', label: '61' },
        { value: '62', label: '62' },
        { value: '63', label: '63' },
        { value: '64', label: '64' },
        { value: '65', label: '65' },
        { value: '66', label: '66' },
        { value: '67', label: '67' },
        { value: '70', label: '70' },
        { value: '71', label: '71' },
        { value: '72', label: '72' },
        { value: '75', label: '75' },
        { value: '76', label: '76' },
        { value: '77', label: '77' },
        { value: '78', label: '78' }
    ],
    20: [
        { value: '10', label: '10' },
        { value: '11', label: '11' },
        { value: '12', label: '12' },
        { value: '15', label: '15' }
    ],
    27: [
        { value: '60', label: '60' },
        { value: '61', label: '61' },
        { value: '62', label: '62' },
        { value: '63', label: '63' },
        { value: '64', label: '64' },
        { value: '65', label: '65' },
        { value: '66', label: '66' },
        { value: '67', label: '67' },
        { value: '68', label: '68' },
        { value: '69', label: '69' },
        { value: '71', label: '71' },
        { value: '72', label: '72' },
        { value: '73', label: '73' },
        { value: '74', label: '74' },
        { value: '76', label: '76' },
        { value: '77', label: '77' },
        { value: '78', label: '78' },
        { value: '79', label: '79' },
        { value: '81', label: '81' },
        { value: '82', label: '82' },
        { value: '83', label: '83' },
        { value: '84', label: '84' }
    ],
    64: [
        { value: '20', label: '20' },
        { value: '21', label: '21' },
        { value: '22', label: '22' },
        { value: '27', label: '27' },
        { value: '28', label: '28' },
        { value: '29', label: '29' }
    ],
    61: [{ value: '4', label: '4' }],
    84: [
        { value: '32', label: '32' },
        { value: '33', label: '33' },
        { value: '34', label: '34' },
        { value: '35', label: '35' },
        { value: '36', label: '36' },
        { value: '37', label: '37' },
        { value: '38', label: '38' },
        { value: '39', label: '39' },
        { value: '52', label: '52' },
        { value: '55', label: '55' },
        { value: '56', label: '56' },
        { value: '58', label: '58' },
        { value: '59', label: '59' },
        { value: '70', label: '70' },
        { value: '76', label: '76' },
        { value: '77', label: '77' },
        { value: '78', label: '78' },
        { value: '79', label: '79' },
        { value: '81', label: '81' },
        { value: '82', label: '82' },
        { value: '83', label: '83' },
        { value: '84', label: '84' },
        { value: '85', label: '85' },
        { value: '86', label: '86' },
        { value: '88', label: '88' },
        { value: '89', label: '89' },
        { value: '90', label: '90' },
        { value: '91', label: '91' },
        { value: '93', label: '93' },
        { value: '94', label: '94' },
        { value: '96', label: '96' },
        { value: '97', label: '97' },
        { value: '98', label: '98' },
        { value: '99', label: '99' }
    ],
    66: [
        { value: '61', label: '61' },
        { value: '63', label: '63' },
        { value: '64', label: '64' },
        { value: '65', label: '65' },
        { value: '66', label: '66' },
        { value: '80', label: '80' },
        { value: '81', label: '81' },
        { value: '82', label: '82' },
        { value: '83', label: '83' },
        { value: '84', label: '84' },
        { value: '85', label: '85' },
        { value: '86', label: '86' },
        { value: '87', label: '87' },
        { value: '88', label: '88' },
        { value: '89', label: '89' },
        { value: '90', label: '90' },
        { value: '91', label: '91' },
        { value: '92', label: '92' },
        { value: '93', label: '93' },
        { value: '94', label: '94' },
        { value: '95', label: '95' },
        { value: '96', label: '96' },
        { value: '97', label: '97' },
        { value: '98', label: '98' },
        { value: '99', label: '99' }
    ],
    63: [
        { value: '813', label: '813' },
        { value: '817', label: '817' },
        { value: '895', label: '895' },
        { value: '896', label: '896' },
        { value: '897', label: '897' },
        { value: '898', label: '898' },
        { value: '905', label: '905' },
        { value: '906', label: '906' },
        { value: '907', label: '907' },
        { value: '908', label: '908' },
        { value: '909', label: '909' },
        { value: '910', label: '910' },
        { value: '911', label: '911' },
        { value: '912', label: '912' },
        { value: '913', label: '913' },
        { value: '914', label: '914' },
        { value: '915', label: '915' },
        { value: '916', label: '916' },
        { value: '917', label: '917' },
        { value: '918', label: '918' },
        { value: '919', label: '919' },
        { value: '920', label: '920' },
        { value: '921', label: '921' },
        { value: '922', label: '922' },
        { value: '923', label: '923' },
        { value: '924', label: '924' },
        { value: '925', label: '925' },
        { value: '926', label: '926' },
        { value: '927', label: '927' },
        { value: '928', label: '928' },
        { value: '929', label: '929' },
        { value: '930', label: '930' },
        { value: '931', label: '931' },
        { value: '932', label: '932' },
        { value: '933', label: '933' },
        { value: '934', label: '934' },
        { value: '935', label: '935' },
        { value: '936', label: '936' },
        { value: '937', label: '937' },
        { value: '938', label: '938' },
        { value: '939', label: '939' },
        { value: '940', label: '940' },
        { value: '941', label: '941' },
        { value: '942', label: '942' },
        { value: '943', label: '943' },
        { value: '944', label: '944' },
        { value: '945', label: '945' },
        { value: '946', label: '946' },
        { value: '947', label: '947' },
        { value: '948', label: '948' },
        { value: '949', label: '949' },
        { value: '950', label: '950' },
        { value: '951', label: '951' },
        { value: '952', label: '952' },
        { value: '953', label: '953' },
        { value: '954', label: '954' },
        { value: '955', label: '955' },
        { value: '956', label: '956' },
        { value: '961', label: '961' },
        { value: '962', label: '962' },
        { value: '963', label: '963' },
        { value: '964', label: '964' },
        { value: '965', label: '965' },
        { value: '966', label: '966' },
        { value: '967', label: '967' },
        { value: '968', label: '968' },
        { value: '969', label: '969' },
        { value: '970', label: '970' },
        { value: '975', label: '975' },
        { value: '976', label: '976' },
        { value: '977', label: '977' },
        { value: '981', label: '981' },
        { value: '985', label: '985' },
        { value: '989', label: '989' },
        { value: '991', label: '991' },
        { value: '992', label: '992' },
        { value: '993', label: '993' },
        { value: '994', label: '994' },
        { value: '995', label: '995' },
        { value: '996', label: '996' },
        { value: '997', label: '997' },
        { value: '998', label: '998' },
        { value: '999', label: '999' }
    ],
    62: [
        { value: '811', label: '811' },
        { value: '812', label: '812' },
        { value: '813', label: '813' },
        { value: '814', label: '814' },
        { value: '815', label: '815' },
        { value: '816', label: '816' },
        { value: '817', label: '817' },
        { value: '818', label: '818' },
        { value: '819', label: '819' },
        { value: '821', label: '821' },
        { value: '822', label: '822' },
        { value: '823', label: '823' },
        { value: '831', label: '831' },
        { value: '832', label: '832' },
        { value: '833', label: '833' },
        { value: '838', label: '838' },
        { value: '851', label: '851' },
        { value: '852', label: '852' },
        { value: '853', label: '853' },
        { value: '855', label: '855' },
        { value: '856', label: '856' },
        { value: '857', label: '857' },
        { value: '858', label: '858' },
        { value: '859', label: '859' },
        { value: '877', label: '877' },
        { value: '878', label: '878' },
        { value: '881', label: '881' },
        { value: '882', label: '882' },
        { value: '883', label: '883' },
        { value: '884', label: '884' },
        { value: '885', label: '885' },
        { value: '886', label: '886' },
        { value: '887', label: '887' },
        { value: '888', label: '888' },
        { value: '889', label: '889' },
        { value: '895', label: '895' },
        { value: '896', label: '896' },
        { value: '897', label: '897' },
        { value: '898', label: '898' },
        { value: '899', label: '899' }
    ],
    60: [
        { value: '10', label: '10' },
        { value: '11', label: '11' },
        { value: '12', label: '12' },
        { value: '13', label: '13' },
        { value: '14', label: '14' },
        { value: '16', label: '16' },
        { value: '17', label: '17' },
        { value: '18', label: '18' },
        { value: '19', label: '19' }
    ],
    65: [
        { value: '8', label: '8' },
        { value: '9', label: '9' }
    ],
    853: [{ value: '6', label: '6' }],
    852: [
        { value: '4', label: '4' },
        { value: '5', label: '5' },
        { value: '6', label: '6' },
        { value: '7', label: '7' },
        { value: '8', label: '8' },
        { value: '9', label: '9' }
    ],
    82: [{ value: '10', label: '10' }],
    81: [
        { value: '70', label: '70' },
        { value: '80', label: '80' },
        { value: '90', label: '90' }
    ],
    86: [
        { value: '130', label: '130' },
        { value: '131', label: '131' },
        { value: '132', label: '132' },
        { value: '133', label: '133' },
        { value: '134', label: '134' },
        { value: '135', label: '135' },
        { value: '136', label: '136' },
        { value: '137', label: '137' },
        { value: '138', label: '138' },
        { value: '139', label: '139' },
        { value: '145', label: '145' },
        { value: '147', label: '147' },
        { value: '148', label: '148' },
        { value: '149', label: '149' },
        { value: '150', label: '150' },
        { value: '151', label: '151' },
        { value: '152', label: '152' },
        { value: '153', label: '153' },
        { value: '155', label: '155' },
        { value: '156', label: '156' },
        { value: '157', label: '157' },
        { value: '158', label: '158' },
        { value: '159', label: '159' },
        { value: '166', label: '166' },
        { value: '167', label: '167' },
        { value: '170', label: '170' },
        { value: '171', label: '171' },
        { value: '172', label: '172' },
        { value: '173', label: '173' },
        { value: '174', label: '174' },
        { value: '175', label: '175' },
        { value: '176', label: '176' },
        { value: '177', label: '177' },
        { value: '178', label: '178' },
        { value: '180', label: '180' },
        { value: '181', label: '181' },
        { value: '182', label: '182' },
        { value: '183', label: '183' },
        { value: '184', label: '184' },
        { value: '185', label: '185' },
        { value: '186', label: '186' },
        { value: '187', label: '187' },
        { value: '188', label: '188' },
        { value: '189', label: '189' },
        { value: '190', label: '190' },
        { value: '191', label: '191' },
        { value: '192', label: '192' },
        { value: '193', label: '193' },
        { value: '195', label: '195' },
        { value: '196', label: '196' },
        { value: '197', label: '197' },
        { value: '198', label: '198' },
        { value: '199', label: '199' }
    ],
    94: [
        { value: '70', label: '70' },
        { value: '71', label: '71' },
        { value: '72', label: '72' },
        { value: '74', label: '74' },
        { value: '75', label: '75' },
        { value: '76', label: '76' },
        { value: '77', label: '77' },
        { value: '78', label: '78' }
    ],
    880: [
        { value: '13', label: '13' },
        { value: '14', label: '14' },
        { value: '15', label: '15' },
        { value: '16', label: '16' },
        { value: '17', label: '17' },
        { value: '18', label: '18' },
        { value: '19', label: '19' }
    ],
    92: [
        { value: '300', label: '300' },
        { value: '301', label: '301' },
        { value: '302', label: '302' },
        { value: '303', label: '303' },
        { value: '304', label: '304' },
        { value: '305', label: '305' },
        { value: '306', label: '306' },
        { value: '307', label: '307' },
        { value: '308', label: '308' },
        { value: '309', label: '309' },
        { value: '310', label: '310' },
        { value: '311', label: '311' },
        { value: '312', label: '312' },
        { value: '313', label: '313' },
        { value: '314', label: '314' },
        { value: '315', label: '315' },
        { value: '316', label: '316' },
        { value: '317', label: '317' },
        { value: '318', label: '318' },
        { value: '319', label: '319' },
        { value: '320', label: '320' },
        { value: '321', label: '321' },
        { value: '322', label: '322' },
        { value: '323', label: '323' },
        { value: '324', label: '324' },
        { value: '325', label: '325' },
        { value: '326', label: '326' },
        { value: '327', label: '327' },
        { value: '328', label: '328' },
        { value: '329', label: '329' },
        { value: '330', label: '330' },
        { value: '331', label: '331' },
        { value: '332', label: '332' },
        { value: '333', label: '333' },
        { value: '334', label: '334' },
        { value: '335', label: '335' },
        { value: '336', label: '336' },
        { value: '337', label: '337' },
        { value: '338', label: '338' },
        { value: '339', label: '339' },
        { value: '340', label: '340' },
        { value: '341', label: '341' },
        { value: '342', label: '342' },
        { value: '343', label: '343' },
        { value: '344', label: '344' },
        { value: '345', label: '345' },
        { value: '346', label: '346' },
        { value: '347', label: '347' },
        { value: '348', label: '348' },
        { value: '349', label: '349' },
        { value: '355', label: '355' },
        { value: '370', label: '370' },
        { value: '371', label: '371' }
    ],
    91: [
        { value: '6', label: '6' },
        { value: '7', label: '7' },
        { value: '8', label: '8' },
        { value: '9', label: '9' }
    ],
    994: [
        { value: '40', label: '40' },
        { value: '50', label: '50' },
        { value: '51', label: '51' },
        { value: '55', label: '55' },
        { value: '60', label: '60' },
        { value: '70', label: '70' },
        { value: '77', label: '77' }
    ],
    374: [
        { value: '33', label: '33' },
        { value: '41', label: '41' },
        { value: '43', label: '43' },
        { value: '44', label: '44' },
        { value: '50', label: '50' },
        { value: '55', label: '55' },
        { value: '66', label: '66' },
        { value: '77', label: '77' },
        { value: '91', label: '91' },
        { value: '93', label: '93' },
        { value: '94', label: '94' },
        { value: '95', label: '95' },
        { value: '96', label: '96' },
        { value: '97', label: '97' },
        { value: '98', label: '98' },
        { value: '99', label: '99' }
    ],
    995: [
        { value: '511', label: '511' },
        { value: '514', label: '514' },
        { value: '551', label: '551' },
        { value: '555', label: '555' },
        { value: '557', label: '557' },
        { value: '558', label: '558' },
        { value: '559', label: '559' },
        { value: '568', label: '568' },
        { value: '570', label: '570' },
        { value: '571', label: '571' },
        { value: '574', label: '574' },
        { value: '577', label: '577' },
        { value: '578', label: '578' },
        { value: '579', label: '579' },
        { value: '591', label: '591' },
        { value: '592', label: '592' },
        { value: '593', label: '593' },
        { value: '595', label: '595' },
        { value: '596', label: '596' },
        { value: '597', label: '597' },
        { value: '598', label: '598' },
        { value: '599', label: '599' }
    ],
    375: [
        { value: '25', label: '25' },
        { value: '29', label: '29' },
        { value: '33', label: '33' },
        { value: '44', label: '44' }
    ],
    380: [
        { value: '39', label: '39' },
        { value: '50', label: '50' },
        { value: '63', label: '63' },
        { value: '66', label: '66' },
        { value: '67', label: '67' },
        { value: '68', label: '68' },
        { value: '73', label: '73' },
        { value: '75', label: '75' },
        { value: '77', label: '77' },
        { value: '91', label: '91' },
        { value: '92', label: '92' },
        { value: '93', label: '93' },
        { value: '94', label: '94' },
        { value: '95', label: '95' },
        { value: '96', label: '96' },
        { value: '97', label: '97' },
        { value: '98', label: '98' },
        { value: '99', label: '99' }
    ],
    7: [
        // Russia
        { value: '900', label: '900' },
        { value: '901', label: '901' },
        { value: '902', label: '902' },
        { value: '903', label: '903' },
        { value: '904', label: '904' },
        { value: '905', label: '905' },
        { value: '906', label: '906' },
        { value: '908', label: '908' },
        { value: '909', label: '909' },
        { value: '910', label: '910' },
        { value: '911', label: '911' },
        { value: '912', label: '912' },
        { value: '913', label: '913' },
        { value: '914', label: '914' },
        { value: '915', label: '915' },
        { value: '916', label: '916' },
        { value: '917', label: '917' },
        { value: '918', label: '918' },
        { value: '919', label: '919' },
        { value: '920', label: '920' },
        { value: '921', label: '921' },
        { value: '922', label: '922' },
        { value: '923', label: '923' },
        { value: '924', label: '924' },
        { value: '925', label: '925' },
        { value: '926', label: '926' },
        { value: '927', label: '927' },
        { value: '928', label: '928' },
        { value: '929', label: '929' },
        { value: '930', label: '930' },
        { value: '931', label: '931' },
        { value: '932', label: '932' },
        { value: '933', label: '933' },
        { value: '934', label: '934' },
        { value: '936', label: '936' },
        { value: '937', label: '937' },
        { value: '938', label: '938' },
        { value: '939', label: '939' },
        { value: '950', label: '950' },
        { value: '951', label: '951' },
        { value: '952', label: '952' },
        { value: '953', label: '953' },
        { value: '958', label: '958' },
        { value: '960', label: '960' },
        { value: '961', label: '961' },
        { value: '962', label: '962' },
        { value: '963', label: '963' },
        { value: '964', label: '964' },
        { value: '965', label: '965' },
        { value: '966', label: '966' },
        { value: '967', label: '967' },
        { value: '968', label: '968' },
        { value: '969', label: '969' },
        { value: '970', label: '970' },
        { value: '971', label: '971' },
        { value: '977', label: '977' },
        { value: '978', label: '978' },
        { value: '980', label: '980' },
        { value: '981', label: '981' },
        { value: '982', label: '982' },
        { value: '983', label: '983' },
        { value: '984', label: '984' },
        { value: '985', label: '985' },
        { value: '986', label: '986' },
        { value: '987', label: '987' },
        { value: '988', label: '988' },
        { value: '989', label: '989' },
        { value: '991', label: '991' },
        { value: '992', label: '992' },
        { value: '993', label: '993' },
        { value: '994', label: '994' },
        { value: '995', label: '995' },
        { value: '996', label: '996' },
        { value: '999', label: '999' },

        // Kazakhstan
        { value: '700', label: '700' },
        { value: '701', label: '701' },
        { value: '702', label: '702' },
        { value: '705', label: '705' },
        { value: '707', label: '707' },
        { value: '708', label: '708' },
        { value: '747', label: '747' },
        { value: '771', label: '771' },
        { value: '775', label: '775' },
        { value: '776', label: '776' },
        { value: '777', label: '777' },
        { value: '778', label: '778' }
    ],
    90: [
        { value: '500', label: '500' },
        { value: '501', label: '501' },
        { value: '502', label: '502' },
        { value: '503', label: '503' },
        { value: '504', label: '504' },
        { value: '505', label: '505' },
        { value: '506', label: '506' },
        { value: '507', label: '507' },
        { value: '508', label: '508' },
        { value: '509', label: '509' },

        { value: '530', label: '530' },
        { value: '531', label: '531' },
        { value: '532', label: '532' },
        { value: '533', label: '533' },
        { value: '534', label: '534' },
        { value: '535', label: '535' },
        { value: '536', label: '536' },
        { value: '537', label: '537' },
        { value: '538', label: '538' },
        { value: '539', label: '539' },

        { value: '540', label: '540' },
        { value: '541', label: '541' },
        { value: '542', label: '542' },
        { value: '543', label: '543' },
        { value: '544', label: '544' },
        { value: '545', label: '545' },
        { value: '546', label: '546' },
        { value: '547', label: '547' },
        { value: '548', label: '548' },
        { value: '549', label: '549' },

        { value: '550', label: '550' },
        { value: '551', label: '551' },
        { value: '552', label: '552' },
        { value: '553', label: '553' },
        { value: '554', label: '554' },
        { value: '555', label: '555' },
        { value: '556', label: '556' },
        { value: '557', label: '557' },
        { value: '558', label: '558' },
        { value: '559', label: '559' }
    ],
    351: [
        { value: '91', label: '91' },
        { value: '92', label: '92' },
        { value: '93', label: '93' },
        { value: '96', label: '96' }
    ],
    30: [
        { value: '690', label: '690' },
        { value: '691', label: '691' },
        { value: '693', label: '693' },
        { value: '694', label: '694' },
        { value: '695', label: '695' },
        { value: '697', label: '697' },
        { value: '698', label: '698' },
        { value: '699', label: '699' }
    ],
    40: [
        { value: '70', label: '70' },
        { value: '71', label: '71' },
        { value: '72', label: '72' },
        { value: '73', label: '73' },
        { value: '74', label: '74' },
        { value: '75', label: '75' },
        { value: '76', label: '76' },
        { value: '77', label: '77' },
        { value: '78', label: '78' },
        { value: '79', label: '79' }
    ],
    36: [
        { value: '20', label: '20' },
        { value: '30', label: '30' },
        { value: '31', label: '31' },
        { value: '50', label: '50' },
        { value: '70', label: '70' }
    ],
    421: [
        { value: '901', label: '901' },
        { value: '902', label: '902' },
        { value: '903', label: '903' },
        { value: '904', label: '904' },
        { value: '905', label: '905' },
        { value: '906', label: '906' },
        { value: '907', label: '907' },
        { value: '908', label: '908' },
        { value: '910', label: '910' },
        { value: '911', label: '911' },
        { value: '912', label: '912' },
        { value: '914', label: '914' },
        { value: '915', label: '915' },
        { value: '916', label: '916' },
        { value: '917', label: '917' },
        { value: '918', label: '918' },
        { value: '919', label: '919' },
        { value: '940', label: '940' },
        { value: '944', label: '944' },
        { value: '948', label: '948' },
        { value: '949', label: '949' },
        { value: '950', label: '950' },
        { value: '951', label: '951' },
        { value: '952', label: '952' },
        { value: '954', label: '954' },
        { value: '955', label: '955' },
        { value: '956', label: '956' },
        { value: '957', label: '957' }
    ],
    420: [
        { value: '601', label: '601' },
        { value: '602', label: '602' },
        { value: '603', label: '603' },
        { value: '604', label: '604' },
        { value: '605', label: '605' },
        { value: '606', label: '606' },
        { value: '607', label: '607' },
        { value: '608', label: '608' },
        { value: '702', label: '702' },
        { value: '703', label: '703' },
        { value: '704', label: '704' },
        { value: '705', label: '705' },
        { value: '72', label: '72' },
        { value: '73', label: '73' },
        { value: '77', label: '77' },
        { value: '790', label: '790' },
        { value: '791', label: '791' },
        { value: '792', label: '792' },
        { value: '793', label: '793' },
        { value: '794', label: '794' },
        { value: '795', label: '795' },
        { value: '797', label: '797' },
        { value: '799', label: '799' }
    ],
    32: [
        { value: '46', label: '46' },
        { value: '47', label: '47' },
        { value: '48', label: '48' },
        { value: '49', label: '49' }
    ],
    43: [
        { value: '650', label: '650' },
        { value: '660', label: '660' },
        { value: '664', label: '664' },
        { value: '665', label: '665' },
        { value: '667', label: '667' },
        { value: '670', label: '670' },
        { value: '676', label: '676' },
        { value: '677', label: '677' },
        { value: '680', label: '680' },
        { value: '681', label: '681' },
        { value: '688', label: '688' },
        { value: '690', label: '690' },
        { value: '699', label: '699' }
    ],
    48: [
        { value: '45', label: '45' },
        { value: '50', label: '50' },
        { value: '51', label: '51' },
        { value: '53', label: '53' },
        { value: '57', label: '57' },
        { value: '60', label: '60' },
        { value: '66', label: '66' },
        { value: '69', label: '69' },
        { value: '72', label: '72' },
        { value: '73', label: '73' },
        { value: '78', label: '78' },
        { value: '79', label: '79' },
        { value: '88', label: '88' }
    ],
    45: [
        { value: '20', label: '20' },
        { value: '21', label: '21' },
        { value: '22', label: '22' },
        { value: '23', label: '23' },
        { value: '24', label: '24' },
        { value: '25', label: '25' },
        { value: '26', label: '26' },
        { value: '27', label: '27' },
        { value: '28', label: '28' },
        { value: '29', label: '29' },
        { value: '30', label: '30' },
        { value: '31', label: '31' },
        { value: '40', label: '40' },
        { value: '41', label: '41' },
        { value: '42', label: '42' },
        { value: '49', label: '49' },
        { value: '50', label: '50' },
        { value: '51', label: '51' },
        { value: '52', label: '52' },
        { value: '53', label: '53' },
        { value: '54', label: '54' },
        { value: '55', label: '55' },
        { value: '60', label: '60' },
        { value: '61', label: '61' },
        { value: '71', label: '71' },
        { value: '81', label: '81' },
        { value: '91', label: '91' },
        { value: '92', label: '92' },
        { value: '93', label: '93' }
    ],
    47: [
        { value: '4', label: '4' },
        { value: '9', label: '9' }
    ],
    46: [
        { value: '70', label: '70' },
        { value: '72', label: '72' },
        { value: '73', label: '73' },
        { value: '76', label: '76' },
        { value: '79', label: '79' }
    ],
    41: [
        { value: '75', label: '75' },
        { value: '76', label: '76' },
        { value: '77', label: '77' },
        { value: '78', label: '78' },
        { value: '79', label: '79' }
    ],
    31: [{ value: '6', label: '6' }],
    971: [
        { value: '50', label: '50' },
        { value: '52', label: '52' },
        { value: '54', label: '54' },
        { value: '55', label: '55' },
        { value: '56', label: '56' },
        { value: '58', label: '58' }
    ],
    972: [
        { value: '50', label: '50' },
        { value: '52', label: '52' },
        { value: '53', label: '53' },
        { value: '54', label: '54' },
        { value: '55', label: '55' },
        { value: '56', label: '56' },
        { value: '58', label: '58' },
        { value: '59', label: '59' }
    ],
    1: [],
    44: [
        { value: '71', label: '71' },
        { value: '73', label: '73' },
        { value: '74', label: '74' },
        { value: '75', label: '75' },
        { value: '7624', label: '7624' },
        { value: '77', label: '77' },
        { value: '78', label: '78' },
        { value: '79', label: '79' }
    ],
    49: [
        { value: '15', label: '15' },
        { value: '16', label: '16' },
        { value: '17', label: '17' }
    ],
    33: [
        { value: '6', label: '6' },
        { value: '7', label: '7' }
    ],
    39: [
        { value: '320', label: '320' },
        { value: '322', label: '322' },
        { value: '323', label: '323' },
        { value: '324', label: '324' },
        { value: '327', label: '327' },
        { value: '328', label: '328' },
        { value: '329', label: '329' },

        { value: '330', label: '330' },
        { value: '331', label: '331' },
        { value: '333', label: '333' },
        { value: '334', label: '334' },
        { value: '335', label: '335' },
        { value: '336', label: '336' },
        { value: '337', label: '337' },
        { value: '338', label: '338' },
        { value: '339', label: '339' },

        { value: '340', label: '340' },
        { value: '342', label: '342' },
        { value: '343', label: '343' },
        { value: '344', label: '344' },
        { value: '345', label: '345' },
        { value: '346', label: '346' },
        { value: '347', label: '347' },
        { value: '348', label: '348' },
        { value: '349', label: '349' },

        { value: '350', label: '350' },
        { value: '351', label: '351' },
        { value: '352', label: '352' },
        { value: '353', label: '353' },

        { value: '360', label: '360' },
        { value: '363', label: '363' },
        { value: '366', label: '366' },
        { value: '368', label: '368' },

        { value: '370', label: '370' },
        { value: '371', label: '371' },
        { value: '373', label: '373' },
        { value: '375', label: '375' },
        { value: '376', label: '376' },
        { value: '377', label: '377' },
        { value: '379', label: '379' },

        { value: '380', label: '380' },
        { value: '383', label: '383' },
        { value: '388', label: '388' },
        { value: '389', label: '389' },

        { value: '390', label: '390' },
        { value: '391', label: '391' },
        { value: '392', label: '392' },
        { value: '393', label: '393' },
        { value: '397', label: '397' }
    ],
    34: [
        { value: '6', label: '6' },
        { value: '71', label: '71' },
        { value: '72', label: '72' },
        { value: '73', label: '73' },
        { value: '74', label: '74' }
    ]
}

export const israelRetailBanks = [
    { key: 4, heb_name: 'בנק יהב לעובדי המדינה בע"מ', eng_name: 'Bank Yahav for State Employees Ltd' },
    { key: 9, heb_name: 'בנק הדואר', eng_name: 'Israel Postal Bank Ltd' },
    { key: 10, heb_name: 'בנק לאומי לישראל בע"מ', eng_name: 'Bank Leumi Le-Israel Ltd' },
    { key: 11, heb_name: 'בנק דיסקונט לישראל בע"מ', eng_name: 'Israel Discount Bank Ltd' },
    { key: 12, heb_name: 'בנק הפועלים בע"מ', eng_name: 'Bank Hapoalim Ltd' },
    { key: 14, heb_name: 'בנק אוצר החייל בע"מ', eng_name: 'Bank Otsar Hahayal Ltd' },
    { key: 17, heb_name: 'בנק מרכנתיל דיסקונט בע"מ', eng_name: 'Mercantile Discount Bank Ltd' },
    { key: 18, heb_name: 'וואן זירו הבנק הדיגיטלי בע"מ', eng_name: 'One Zero Digital Bank Ltd' },
    { key: 20, heb_name: 'בנק מזרחי טפחות בע"מ', eng_name: 'Bank Mizrahi-Tefahot Ltd' },
    { key: 26, heb_name: 'יובנק בע"מ', eng_name: 'U-Bank Ltd' },
    { key: 31, heb_name: 'הבנק הבינלאומי הראשון לישראל בע"מ', eng_name: 'First International Bank of Israel Ltd' },
    { key: 46, heb_name: 'בנק מסד בע"מ', eng_name: 'Bank Massad Ltd' },
    { key: 54, heb_name: 'בנק ירושלים בע"מ', eng_name: 'Bank of Jerusalem Ltd' }
]

export const cardNetworks = [
    { name: 'Visa', pattern: /^4/ },
    { name: 'Mastercard', pattern: /^5[1-5]|^2(2[2-9][1-9]|[3-6]\d{2}|7[01]\d|720)/ },
    { name: 'American Express', pattern: /^3[47]/ },
    { name: 'Diners Club', pattern: /^3(?:0[0-5]|[68])/ },
    { name: 'Discover', pattern: /^6(?:011|5)/ },
    { name: 'UnionPay', pattern: /^62/ }
]

export const luhnCheck = (digits: string): boolean => {
    let sum = 0
    let shouldDouble = false
    for (let i = digits.length - 1; i >= 0; i--) {
        let d = parseInt(digits[i], 10)
        if (shouldDouble) {
            d *= 2
            if (d > 9) d -= 9
        }
        sum += d
        shouldDouble = !shouldDouble
    }
    return sum % 10 === 0
}
